import {Component, inject, OnInit} from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient, HttpHeaders} from '@angular/common/http';

@Component({
  selector: 'app-refund',
  imports: [],
  templateUrl: './refund.html',
  styleUrl: './refund.scss'
})
export class Refund implements OnInit{
  env = environment;
  token = true;
  accessToken: string | null = '';
  tokenExpired = true;
  email = '';
  http = inject(HttpClient)
  refundDone = false;

  ngOnInit() {
    this.refundDone = false;
    this.tokenExpired = this.checkTokenExpiration();
    this.checkMail();
  }
  checkTokenExpiration(): boolean {
    const token = localStorage.getItem('accessToken');
    this.accessToken = token;
    if (token === null) return true
    try {
      const decoded = this.decodeJWT(token);
      if (!decoded || !decoded.exp) return true;
      const now = Math.floor(Date.now() / 1000); // Current time in seconds
      // accesstoken < now ; false means valid
      return decoded.exp < now;
    } catch (error) {
      return true;
    }

  }

  private decodeJWT(token: string): any {
    const parts = token.split('.');
    if (parts.length !== 3) return null;

    try {
      return JSON.parse(atob(parts[1]));
    } catch (error) {
      console.error('Invalid JWT format:', error);
      return null;
    }
  }

  checkMail() {
    const token = localStorage.getItem("accessToken");

    fetch( `${this.env.apiBaseUrl}/get-email`, {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    })
      .then(response => response.json())
      .then(data => {
          this.email = data.email;
        }
      )
      .catch(err => console.error("Error:", err))
      .finally(
      );
  }


  requestRefund(email: string) {
    console.log(this.accessToken)
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`
    });

    const body = { email };

    return this.http.post(`${this.env.apiBaseUrl}/refund`, body, { headers }).subscribe({
      next: (response) => {console.log('Refund success:', response)
        this.refundDone = true;
      },
      error: (error) => console.error('Refund error:', error)
    });
  }
}
